export default __webpack_public_path__ + "static/media/pixel-video.5e64aa0c.mp4";